import { useEffect, useState } from "react";
import { AppLayout } from "@/components/layout/AppLayout";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { BusinessUnitsTab } from "@/components/org/BusinessUnitsTab";
import { UsersTab } from "@/components/org/UsersTab";
import { RolesMatrixTab } from "@/components/org/RolesMatrixTab";
import { usePermissions } from "@/context/PermissionsContext";
import { ShieldAlert } from "lucide-react";

export default function OrgManagementPage() {
  const { can, loaded } = usePermissions();

  if (!loaded) return <AppLayout title="Organisation Management"><div className="h-64 bg-white border border-slate-200 rounded-lg shimmer" /></AppLayout>;

  if (!can("org_mgmt", "view")) {
    return (
      <AppLayout title="Organisation Management">
        <div className="max-w-md mx-auto mt-16 text-center">
          <div className="w-14 h-14 rounded-full bg-rose-50 border border-rose-200 flex items-center justify-center mx-auto mb-4">
            <ShieldAlert className="w-6 h-6 text-rose-700" />
          </div>
          <h2 className="font-display text-xl font-semibold text-slate-900">Access restricted</h2>
          <p className="text-slate-600 mt-2 text-sm">Your role does not have access to Organisation Management. Contact an administrator if you believe this is an error.</p>
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout title="Organisation Management" subtitle="Business Units · Users · Roles & Permissions">
      <Tabs defaultValue="bus">
        <TabsList className="bg-white border border-slate-200 p-1 h-auto mb-6">
          <TabsTrigger data-testid="org-tab-bus" value="bus" className="data-[state=active]:bg-slate-100 rounded-md text-xs">Business Units</TabsTrigger>
          <TabsTrigger data-testid="org-tab-users" value="users" className="data-[state=active]:bg-slate-100 rounded-md text-xs">Users</TabsTrigger>
          <TabsTrigger data-testid="org-tab-roles" value="roles" className="data-[state=active]:bg-slate-100 rounded-md text-xs">Roles & Permissions</TabsTrigger>
        </TabsList>
        <TabsContent value="bus"><BusinessUnitsTab /></TabsContent>
        <TabsContent value="users"><UsersTab /></TabsContent>
        <TabsContent value="roles"><RolesMatrixTab /></TabsContent>
      </Tabs>
    </AppLayout>
  );
}
